package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class TagDto(
    val id: String,
    val name: String
)

@Serializable
data class TagWithCountDto(
    val id: String,
    val name: String,
    val podcastCount: Int = 0,
    val audiobookCount: Int = 0
)

@Serializable
data class AddTagRequest(
    val tagId: String? = null,
    val name: String? = null
)

@Serializable
data class CreateTagRequest(
    val name: String
)

@Serializable
data class UpdateTagRequest(
    val name: String
)

@Serializable
data class TagListResponse(
    val tags: List<TagDto>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)

@Serializable
data class MergeTagRequest(
    val sourceTagId: String,
    val targetTagId: String
)

@Serializable
data class MergeTagResponse(
    val targetTag: TagDto,
    val mergedCount: Int
)
